import { FC, useState, useEffect, useRef, useId } from "react";
import s from "./ModalAddCamera.module.scss";
import { useDispatch } from "react-redux";
import { Close } from "../../../assets/svg/Close";
import {
  addOrUpdateItemsAttribute,
  changeShowModal,
} from "../../../redux/actions";
import { InputWrapper } from "../../../shared/InputWrapper/InputWrapper";
import { ButtonWrapper } from "../../../shared/ButtonWrapper/ButtonWrapper";
import { popUp } from "../../../features/popUp/PopUp";
import updateAttributeApi from "../../api/attributes/updateAttributeApi";
import createAttributeApi from "../../api/attributes/createAttributeApi";
import { optionsTag } from "../../../utils/constants";
import { loadItemsProductInState } from "../../../features/functions/loadItemsProductInState";
import { CoodrinateCameraComponent } from "./components/CoodrinateCameraComponent/CoodrinateCameraComponent";

type ModalAddCameraT = {
  closeFunc: any;
  data: any;
};
type valuesT = {
  name: string;
  position: string;
  rotation: string;
  FOV: string;
  steps: string;
  productRotation: any;
};
export const ModalAddCamera: FC<ModalAddCameraT> = ({ ...props }) => {
  const { closeFunc, data } = props;
  const {
    attrId,
    itemId,
    name,
    position,
    rotation,
    FOV,
    steps,
    productRotation,
  } = data;
  const text = itemId ? "Edit camera" : "Add new camera";
  const wrapperRef: any = useRef(null);
  const dispatch = useDispatch();

  const [values, setValues]: any = useState<valuesT>({
    name,
    position,
    rotation,
    FOV,
    steps,
    productRotation,
  });
  const errorsIfNullValue = [
    {
      value: values.name,
      message: "The name field must not be empty",
    },
    {
      value: values.position,
      message: "The position field must not be empty",
    },
    {
      value: values.rotation,
      message: "The rotation field must not be empty",
    },
    {
      value: values.FOV,
      message: "The FOV field must not be empty",
    },
    {
      value: values.steps,
      message: "The steps field must not be empty",
    },
    {
      value: values.productRotation,
      message: "The Product Rotation field must not be empty",
    },
  ];
  useEffect(() => {
    const handleClickOutside =
      (wrapperRef: any, closeFunc: any) => (event: any) => {
        if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
          closeFunc();
        }
      };
    document.addEventListener(
      "mousedown",
      handleClickOutside(wrapperRef, closeFunc)
    );
    return () => {
      document.removeEventListener(
        "mousedown",
        handleClickOutside(wrapperRef, closeFunc)
      );
    };
  }, [wrapperRef]);

  async function addOrEditAttribute() {
    dispatch(changeShowModal({ nameModal: "loader", stateModal: true }));

    let errorCounter: number = 0;
    errorsIfNullValue.map((error: any) => {
      if (!error.value) {
        errorCounter++;
        popUp({ type: "failure", message: error.message });
      }
    });
    if (errorCounter === 0) {
      const dataParams = {
        name: values.name,
        stageId: Number(attrId),
        fov: Number(values.FOV),
        rotationSteps: Number(values.steps),
        position: {
          x: Number(values.position.x),
          y: Number(values.position.y),
          z: Number(values.position.z),
        },
        productRotation: {
          x: Number(values.productRotation.x),
          y: Number(values.productRotation.y),
          z: Number(values.productRotation.z),
        },
        rotation: {
          x: Number(values.rotation.x),
          y: Number(values.rotation.y),
          z: Number(values.rotation.z),
        },
      };

      // редагуємо
      if (itemId) {
        const updatedOption = await updateAttributeApi({
          id: itemId,
          values: dataParams,
          url: optionsTag["cameras"].update.url,
          request: optionsTag["cameras"].update.request,
        });
        if (updatedOption) {
          dispatch(
            addOrUpdateItemsAttribute({
              attrId: attrId,
              itemId: updatedOption.id,
              attrName: "stages",
              attrValue: updatedOption,
              type: "update",
            })
          );

          popUp({
            type: "success",
            message: `camera ${values.name} successfully changed`,
          });
        }
      } else {
        // створюємо

        const newAttr = await createAttributeApi({
          values: {
            ...dataParams,
          },
          url: optionsTag["cameras"].create.url,
          request: optionsTag["cameras"].create.request,
        });
        if (newAttr) {
          dispatch(
            addOrUpdateItemsAttribute({
              attrId: attrId,
              itemId: newAttr.id,
              attrName: "stages",
              attrValue: newAttr,
              type: "add",
            })
          );
          popUp({
            type: "success",
            message: "camera has been successfully created",
          });
        }
      }
      // const projects = await getProjectsApi();
      // dispatch(setAllProjects({ projects: projects.rows }));
      loadItemsProductInState({ dispatch });

      closeFunc();
    }
    dispatch(changeShowModal({ nameModal: "loader", stateModal: false }));
  }

  return (
    <div className={s.wrapper} ref={wrapperRef}>
      <div className={s.head}>
        <span>{text}</span>
        <div className={s.close} onClick={closeFunc}>
          <Close />
        </div>
      </div>
      <div className={s.content}>
        <InputWrapper
          name="name"
          setValue={(value: any) => setValues({ ...values, name: value })}
          value={values.name}
          type="text"
          isRequired={true}
          placeholder="Enter name"
        />

        <div className={s.params}>
          <CoodrinateCameraComponent setValues={setValues} values={values} />
        </div>
        <div className={s.params}>
          <InputWrapper
            name="FOV"
            setValue={(value: any) => setValues({ ...values, FOV: value })}
            value={values.FOV}
            type="number"
            isRequired={true}
            addClassName={s.FOV}
            placeholder="Enter value"
          />
          <InputWrapper
            name="360° steps"
            setValue={(value: any) => setValues({ ...values, steps: value })}
            value={values.steps}
            type="number"
            isRequired={true}
            addClassName={s.steps}
            placeholder="Enter value"
          />
        </div>
        <ButtonWrapper
          clickEvent={addOrEditAttribute}
          text="Save camera"
          type="primary"
        />
      </div>
    </div>
  );
};
